import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "push-record-page" }
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "title-block" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "page-desc" }
const _hoisted_6 = { class: "header-actions" }
const _hoisted_7 = {
  key: 0,
  class: "last-refresh"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "refresh-text" }
const _hoisted_10 = { class: "stat-row" }
const _hoisted_11 = { class: "stat-card stat-total" }
const _hoisted_12 = { class: "stat-icon-wrap" }
const _hoisted_13 = { class: "stat-body" }
const _hoisted_14 = { class: "stat-label" }
const _hoisted_15 = { class: "stat-value" }
const _hoisted_16 = { class: "stat-progress" }
const _hoisted_17 = { class: "stat-tip" }
const _hoisted_18 = { class: "stat-rate" }
const _hoisted_19 = { class: "stat-card stat-completed" }
const _hoisted_20 = { class: "stat-icon-wrap" }
const _hoisted_21 = { class: "stat-body" }
const _hoisted_22 = { class: "stat-label" }
const _hoisted_23 = { class: "stat-value" }
const _hoisted_24 = { class: "stat-tip" }
const _hoisted_25 = { class: "stat-card stat-processing" }
const _hoisted_26 = { class: "stat-icon-wrap" }
const _hoisted_27 = { class: "stat-body" }
const _hoisted_28 = { class: "stat-label" }
const _hoisted_29 = { class: "stat-value" }
const _hoisted_30 = { class: "stat-tip" }
const _hoisted_31 = { class: "stat-card stat-failed" }
const _hoisted_32 = { class: "stat-icon-wrap" }
const _hoisted_33 = { class: "stat-body" }
const _hoisted_34 = { class: "stat-label" }
const _hoisted_35 = { class: "stat-value" }
const _hoisted_36 = { class: "stat-tip" }
const _hoisted_37 = { class: "stat-card stat-expired" }
const _hoisted_38 = { class: "stat-icon-wrap" }
const _hoisted_39 = { class: "stat-body" }
const _hoisted_40 = { class: "stat-label" }
const _hoisted_41 = { class: "stat-value" }
const _hoisted_42 = { class: "stat-tip" }
const _hoisted_43 = { class: "filter-bar" }
const _hoisted_44 = { class: "table-card" }
const _hoisted_45 = { class: "empty-state" }
const _hoisted_46 = { class: "empty-text" }
const _hoisted_47 = { class: "empty-hint" }
const _hoisted_48 = {
  key: 0,
  class: "expand-area"
}
const _hoisted_49 = {
  key: 1,
  class: "expand-loading"
}
const _hoisted_50 = { class: "type-cell" }
const _hoisted_51 = { class: "plan-cell" }
const _hoisted_52 = { class: "plan-name" }
const _hoisted_53 = { class: "plan-ref" }
const _hoisted_54 = { class: "ship-cell" }
const _hoisted_55 = { class: "ship-name" }
const _hoisted_56 = { class: "ship-id" }
const _hoisted_57 = {
  key: 1,
  class: "muted"
}
const _hoisted_58 = {
  key: 0,
  class: "progress-cell"
}
const _hoisted_59 = { class: "progress-text" }
const _hoisted_60 = {
  key: 1,
  class: "muted"
}
const _hoisted_61 = { class: "time-cell" }
const _hoisted_62 = { class: "time-row" }
const _hoisted_63 = { class: "time-tag" }
const _hoisted_64 = { class: "time-row time-sub" }
const _hoisted_65 = { class: "time-tag" }
const _hoisted_66 = { class: "row-actions" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = ["disabled", "onClick"]
const _hoisted_69 = ["disabled", "onClick"]
const _hoisted_70 = { class: "pagination-wrapper" }
const _hoisted_71 = { class: "drawer-header" }
const _hoisted_72 = { class: "drawer-title" }
const _hoisted_73 = {
  key: 0,
  class: "drawer-actions"
}
const _hoisted_74 = ["disabled"]
const _hoisted_75 = ["disabled"]
const _hoisted_76 = {
  key: 0,
  class: "detail-content"
}
const _hoisted_77 = { class: "detail-header" }
const _hoisted_78 = { class: "detail-plan-name" }
const _hoisted_79 = { class: "detail-section" }
const _hoisted_80 = { class: "section-title" }
const _hoisted_81 = { class: "mono" }
const _hoisted_82 = { class: "mono" }
const _hoisted_83 = {
  key: 0,
  class: "muted"
}
const _hoisted_84 = {
  key: 0,
  class: "detail-section"
}
const _hoisted_85 = { class: "section-title" }
const _hoisted_86 = { class: "file-card" }
const _hoisted_87 = { class: "file-info" }
const _hoisted_88 = { class: "file-name" }
const _hoisted_89 = {
  key: 0,
  class: "file-meta"
}
const _hoisted_90 = { class: "meta-value mono" }
const _hoisted_91 = {
  key: 1,
  class: "file-meta"
}
const _hoisted_92 = { class: "meta-value mono" }
const _hoisted_93 = {
  key: 2,
  class: "file-meta"
}
const _hoisted_94 = { class: "meta-value mono" }
const _hoisted_95 = { class: "detail-section" }
const _hoisted_96 = { class: "section-title" }
const _hoisted_97 = { class: "timeline-label" }
const _hoisted_98 = { class: "timeline-label" }
const _hoisted_99 = {
  key: 1,
  class: "muted"
}
const _hoisted_100 = { class: "timeline-label" }
const _hoisted_101 = {
  key: 1,
  class: "muted"
}
const _hoisted_102 = { class: "timeline-label" }
const _hoisted_103 = {
  key: 1,
  class: "muted"
}
const _hoisted_104 = {
  key: 1,
  class: "detail-section"
}
const _hoisted_105 = { class: "section-title" }
const _hoisted_106 = {
  key: 0,
  class: "section-count"
}
const _hoisted_107 = {
  key: 0,
  class: "expand-loading"
}
const _hoisted_108 = {
  key: 2,
  class: "muted"
}

import { loadTranslations, translateName } from "@/composables/useTranslation";
import {
  getPushRecordListApi,
  getPushRecordItemsApi,
  cancelPushRecordApi,
  type PushRecord,
  type PushRecordItem,
} from "@/api/operation/upgradeApi";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  Refresh,
  RefreshLeft,
  RefreshRight,
  Search,
  Loading,
  View,
  DocumentRemove,
  Cpu,
  Cellphone,
  Connection,
  Lightning,
  Promotion,
  CircleCheck,
  CircleClose,
  Clock,
  Document,
} from "@element-plus/icons-vue";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import { useI18n } from "vue-i18n";

const pageSize = 20;
const REFRESH_INTERVAL = 10000;

type AnimatableStats = ReturnType<typeof stats.value>;

export default /*@__PURE__*/_defineComponent({
  __name: 'UpgradeListView',
  setup(__props) {

const { t } = useI18n();

const recordList = ref<PushRecord[]>([]);
const expandedItems = ref<Record<string, PushRecordItem[]>>({});
const loading = ref(false);
const loadingMap = ref<Map<string, boolean>>(new Map());
const currentPage = ref(1);
const total = ref(0);

const query = reactive<{
  type: number | null;
  resultStatus: number | null;
  customerAttitude: number | null;
  timeRange: [Date, Date] | [];
}>({
  type: null,
  resultStatus: null,
  customerAttitude: null,
  timeRange: [],
});

const autoRefresh = ref(false);
const lastRefreshTime = ref<string>("");
let refreshTimer: number | null = null;
const detailVisible = ref(false);
const currentDetail = ref<PushRecord | null>(null);
const detailItems = ref<PushRecordItem[]>([]);
const detailItemsLoading = ref(false);

const typeMeta = (type: number) => {
  const map = {
    1: {
      label: t("UPGLV.filterTypeSvc001"),
      tag: "primary",
      color: "#409EFF",
      icon: Cpu,
    },
    2: {
      label: t("UPGLV.filterTypeSvc004"),
      tag: "success",
      color: "#67C23A",
      icon: Cellphone,
    },
    3: {
      label: t("UPGLV.filterTypeSvc003"),
      tag: "warning",
      color: "#E6A23C",
      icon: Connection,
    },
    4: {
      label: t("UPGLV.filterTypeSvc005"),
      tag: "info",
      color: "#909399",
      icon: Lightning,
    },
  } as const;
  return (
    map[type as 1 | 2 | 3 | 4] ?? {
      label: "未知",
      tag: "",
      color: "#909399",
      icon: DocumentRemove,
    }
  );
};

const typeOptions = computed(() => [
  { label: t("UPGLV.filterTypeAll"), value: null },
  { label: t("UPGLV.filterTypeSvc001"), value: 1 },
  { label: t("UPGLV.filterTypeSvc004"), value: 2 },
  { label: t("UPGLV.filterTypeSvc003"), value: 3 },
  { label: t("UPGLV.filterTypeSvc005"), value: 4 },
]);

const resultStatusOptions = computed(() => [
  { value: 0, label: t("UPGLV.filterResultStatusPending") },
  { value: 1, label: t("UPGLV.filterResultStatusWaiting") },
  { value: 2, label: t("UPGLV.filterResultStatusRunning") },
  { value: 3, label: t("UPGLV.filterResultStatusSuccess") },
  { value: 4, label: t("UPGLV.filterResultStatusFail") },
  { value: 5, label: t("UPGLV.filterResultStatusCanceled") },
  { value: 6, label: t("UPGLV.filterResultStatusExpired") },
  { value: 7, label: t("UPGLV.filterResultStatusPartial") },
]);

const attitudeOptions = computed(() => [
  { value: 0, label: t("UPGLV.filterAttitudePending") },
  { value: 1, label: t("UPGLV.filterAttitudeAgree") },
  { value: 2, label: t("UPGLV.filterAttitudeReject") },
]);

const stats = computed(() => {
  const list = recordList.value;
  const get = (s: number) => list.filter((r) => r.resultStatus === s).length;
  const completed = get(3) + get(7); // 成功 + 部分成功
  const processing = get(0) + get(1) + get(2); // 待确认 + 等待执行 + 升级中
  const failed = get(4) + get(5); // 升级失败 + 已取消
  const expired = get(6);
  const total = list.length;
  const successRate = total ? Math.round((completed / total) * 100) : 0;
  return {
    total,
    successRate,
    completed,
    successCount: get(3),
    partialCount: get(7),
    processing,
    pending: get(0) + get(1),
    upgrading: get(2),
    failed,
    rejected: 0, // 当前 schema 暂未拆分 responseStatus,后续可细化
    upgradeFailed: get(4),
    expired,
  };
});

const buildParams = () => {
  const params: Record<string, unknown> = {
    current: currentPage.value,
    size: pageSize,
  };
  if (query.type) params.type = query.type;
  return params;
};

const filterClientSide = (records: PushRecord[]) => {
  return records.filter((r) => {
    if (query.resultStatus !== null && r.resultStatus !== query.resultStatus)
      return false;
    if (
      query.customerAttitude !== null &&
      r.customerAttitude !== query.customerAttitude
    )
      return false;
    return true;
  });
};

const loadData = async (showToast = false) => {
  loading.value = true;
  try {
    const response = await getPushRecordListApi(buildParams());
    if (response) {
      let records = response.records || [];
      records = filterClientSide(records);
      recordList.value = records;
      total.value = response.total || 0;
      lastRefreshTime.value = new Date().toLocaleTimeString("zh-CN", {
        hour12: false,
      });
      const expandedIds = Object.keys(expandedItems.value);
      expandedItems.value = {};
      for (const id of expandedIds) {
        const r = await getPushRecordItemsApi(id);
        if (r) expandedItems.value[id] = r;
      }
      if (showToast) ElMessage.success("已刷新");
    }
  } finally {
    loading.value = false;
  }
};

const handleQuery = () => {
  currentPage.value = 1;
  loadData();
};

// ==================== 终端固件名（Svc001 [1,4]/[1,5]） ====================
// 注：终端固件名不在推送记录列表中展示（语义错位——固件名是终端属性，非推送事件属性），
// 仅在「创建升级计划」页（CreateUpgradePlanView）中通过 queryEndpointFirmwareApi 展示。

/**
 * 刷新按钮：刷新推送记录列表
 */
const handleRefresh = async () => {
  await loadData(true);
  ElMessage.success("已刷新");
};
const handleReset = () => {
  query.type = null;
  query.resultStatus = null;
  query.customerAttitude = null;
  query.timeRange = [];
  currentPage.value = 1;
  loadData();
};
const handlePageChange = (current: number) => {
  currentPage.value = current;
  loadData();
};

const handleExpandChange = async (row: PushRecord) => {
  if (row.type !== 2 && row.type !== 4) return;
  const r = await getPushRecordItemsApi(row.id);
  if (r) expandedItems.value[row.id] = r;
};

const openDetail = (row: PushRecord) => {
  currentDetail.value = row;
  detailItems.value = [];
  detailVisible.value = true;
};

const onDrawerOpen = async () => {
  if (!currentDetail.value) return;
  if (currentDetail.value.type !== 2 && currentDetail.value.type !== 4) return;
  detailItemsLoading.value = true;
  try {
    const r = await getPushRecordItemsApi(currentDetail.value.id);
    detailItems.value = r || [];
  } finally {
    detailItemsLoading.value = false;
  }
};

const canCancel = (row: PushRecord) =>
  row.resultStatus >= 0 && row.resultStatus <= 2;

// 重试功能暂不开放，返回 false 隐藏所有重试按钮
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const canRetry = (_row: PushRecord) => false;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const handleRetry = async (_row: PushRecord) => {
  ElMessage.info("重试功能待后端接口提供,当前记录已重新加入待处理队列");
  // TODO: 调用后端重试接口（需要 manager-server 提供 POST /pushRecord/retry/{id}）
  // const ok = await retryPushRecordApi(row.id);
  // if (ok) { ElMessage.success("已重试"); loadData(); }
};

// ============ 数字滚动动画 ============
const displayStats = ref<AnimatableStats>({
  total: 0,
  successRate: 0,
  completed: 0,
  successCount: 0,
  partialCount: 0,
  processing: 0,
  pending: 0,
  upgrading: 0,
  failed: 0,
  rejected: 0,
  upgradeFailed: 0,
  expired: 0,
});

const animateNumber = (
  getter: () => number,
  setter: (v: number) => void,
  target: number,
  duration = 700
) => {
  const start = getter();
  if (start === target) return;
  const startTime = performance.now();
  const step = (now: number) => {
    const progress = Math.min((now - startTime) / duration, 1);
    const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
    setter(Math.round(start + (target - start) * eased));
    if (progress < 1) requestAnimationFrame(step);
  };
  requestAnimationFrame(step);
};

watch(
  () => stats.value,
  (nv) => {
    const cur = displayStats.value;
    animateNumber(
      () => cur.total,
      (v) => (cur.total = v),
      nv.total
    );
    animateNumber(
      () => cur.successRate,
      (v) => (cur.successRate = v),
      nv.successRate
    );
    animateNumber(
      () => cur.completed,
      (v) => (cur.completed = v),
      nv.completed
    );
    animateNumber(
      () => cur.successCount,
      (v) => (cur.successCount = v),
      nv.successCount
    );
    animateNumber(
      () => cur.partialCount,
      (v) => (cur.partialCount = v),
      nv.partialCount
    );
    animateNumber(
      () => cur.processing,
      (v) => (cur.processing = v),
      nv.processing
    );
    animateNumber(
      () => cur.pending,
      (v) => (cur.pending = v),
      nv.pending
    );
    animateNumber(
      () => cur.upgrading,
      (v) => (cur.upgrading = v),
      nv.upgrading
    );
    animateNumber(
      () => cur.failed,
      (v) => (cur.failed = v),
      nv.failed
    );
    animateNumber(
      () => cur.upgradeFailed,
      (v) => (cur.upgradeFailed = v),
      nv.upgradeFailed
    );
    animateNumber(
      () => cur.expired,
      (v) => (cur.expired = v),
      nv.expired
    );
  },
  { deep: true, immediate: true }
);

const getRowClassName = ({ row }: { row: PushRecord }) => {
  const classes: string[] = [];
  if (row.type !== 2 && row.type !== 4) {
    classes.push("row-no-expand");
  }
  if (row.resultStatus != null) {
    classes.push(`row-status-${row.resultStatus}`);
  }
  return classes.join(" ");
};

// 判断字符串是否像 URL（历史误用 detail 字段存 URL 的兼容判断）
const isUrlLike = (s: string | null | undefined): boolean => {
  if (!s) return false;
  return /^(https?|mttps|ftp):\/\//i.test(s.trim());
};

// 解析推送记录的文件信息（展示文件名/MD5 及 Svc001 三文件的 MD5/签名文件名，不展示下载 URL）
const fileInfo = computed(() => {
  const record = currentDetail.value;
  if (!record) return null;
  // 1. 主表自身的文件字段（svc001 终端升级 / svc003 终端协议 / svc004 设备协议）
  if (record.fileName || record.fileMd5 || record.filePath) {
    // Svc001 三文件：MD5/签名文件名存于 extraJson（{"md5FileName":"x.md5","signFileName":"x.sig"}）
    let md5FileName = "";
    let signFileName = "";
    if (record.extraJson) {
      try {
        const extra =
          typeof record.extraJson === "string"
            ? JSON.parse(record.extraJson)
            : record.extraJson;
        md5FileName = extra.md5FileName || "";
        signFileName = extra.signFileName || "";
      } catch {
        // extraJson 非法时忽略（历史数据兼容）
      }
    }
    return {
      fileName: record.fileName || "-",
      fileMd5: record.fileMd5 || "",
      md5FileName,
      signFileName,
    };
  }
  return null;
});

const handleCancel = async (row: PushRecord) => {
  try {
    await ElMessageBox.confirm(
      t("UPGLV.confirmCancelText"),
      t("UPGLV.confirmCancelTitle"),
      { type: "warning", confirmButtonText: "确定", cancelButtonText: "取消" }
    );
  } catch {
    return;
  }
  loadingMap.value.set("cancel-" + row.id, true);
  try {
    const response = await cancelPushRecordApi(row.id);
    if (response) {
      ElMessage.success("取消成功");
      await loadData();
    } else {
      ElMessage.error("取消失败");
    }
  } finally {
    loadingMap.value.set("cancel-" + row.id, false);
  }
};

watch(autoRefresh, (val) => {
  if (refreshTimer) {
    clearInterval(refreshTimer);
    refreshTimer = null;
  }
  if (val)
    refreshTimer = window.setInterval(() => loadData(), REFRESH_INTERVAL);
});

onBeforeUnmount(() => {
  if (refreshTimer) clearInterval(refreshTimer);
});

const shortId = (id: string | null | undefined, len = 8) => {
  if (!id) return "-";
  return id.length > len ? id.substring(0, len) + "..." : id;
};

const progressPct = (row: PushRecord) => {
  if (!row.totalItems) return 0;
  return Math.round((row.successItems / row.totalItems) * 100);
};

const progressStatus = (resultStatus: number) => {
  if (resultStatus === 3) return "success";
  if (resultStatus === 4 || resultStatus === 6) return "exception";
  if (resultStatus === 7) return "warning";
  return undefined;
};

const formatTime = (time: string | null | undefined) => {
  if (!time) return "-";
  try {
    return new Date(time).toLocaleString("zh-CN", { hour12: false });
  } catch {
    return time;
  }
};

const nameOfPush = (s: number) =>
  ({ 0: "未推送", 1: "已推送", 2: "推送失败" }[s] ?? "-");
const tagOfPush = (s: number) =>
  ({ 0: "info", 1: "success", 2: "danger" }[s] ?? "info");
const nameOfResp = (s: number) =>
  ({ 0: "等待响应", 1: "已接受", 2: "已拒绝" }[s] ?? "-");
const tagOfResp = (s: number) =>
  ({ 0: "info", 1: "success", 2: "danger" }[s] ?? "info");
const nameOfResult = (s: number) =>
  ({
    0: "待确认",
    1: "等待执行",
    2: "升级中",
    3: "成功",
    4: "失败",
    5: "已取消",
    6: "已过期",
    7: "部分成功",
  }[s] ?? "未知");

// 按业务类型细分文案：协议类(type=3/4)用"已下发"代替"升级中"，超时显示"已过期未回应"
const nameOfResultByType = (s: number, type: number | null | undefined) => {
  if ((type === 3 || type === 4) && s === 2) return "已下发";
  if ((type === 3 || type === 4) && s === 6) return "已过期未回应";
  return nameOfResult(s);
};
const tagOfResult = (s: number) =>
  ({
    0: "info",
    1: "primary",
    2: "warning",
    3: "success",
    4: "danger",
    5: "info",
    6: "warning",
    7: "warning",
  }[s] ?? "info");
const timelineColorOfResult = (s: number) =>
  ({ 3: "#67c23a", 4: "#f56c6c", 6: "#e6a23c", 7: "#e6a23c" }[s] ?? "#909399");
const timelineColorOfResp = (s: number) =>
  ({ 1: "#67c23a", 2: "#f56c6c" }[s] ?? "#909399");
const nameOfAttitude = (s: number | null | undefined) =>
  ({ 0: "待确认", 1: "已同意", 2: "已拒绝" }[s ?? -1] ?? "-");
const tagOfAttitude = (s: number | null | undefined) =>
  ({ 0: "info", 1: "success", 2: "danger" }[s ?? -1] ?? "info");
const nameOfItemResult = (s: number) =>
  ({ 1: "待执行", 2: "升级中", 3: "成功", 4: "失败", 5: "已跳过", 6: "已取消" }[
    s
  ] ?? "-");
const tagOfItemResult = (s: number) =>
  ({ 1: "info", 2: "warning", 3: "success", 4: "danger", 5: "info", 6: "info" }[
    s
  ] ?? "info");
const getSubTypeName = (subType: number) =>
  ({ 1: "BCU", 2: "BSMU", 3: "BAMU", 4: "ITMU", 5: "ITPU", 6: "EMU" }[
    subType
  ] ?? "-");

onMounted(async () => {
  // 确保翻译表就绪：登录后首次进入时 App 挂载阶段的加载因未登录(401)失败，
  // devName 列翻译依赖此缓存；与 App 启动加载共享同一次请求
  await loadTranslations();
  await loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"header-bg\" data-v-e81027d4><svg viewBox=\"0 0 800 200\" preserveAspectRatio=\"none\" class=\"header-svg\" data-v-e81027d4><circle cx=\"100\" cy=\"100\" r=\"180\" fill=\"rgba(255,255,255,0.04)\" data-v-e81027d4></circle><circle cx=\"650\" cy=\"50\" r=\"140\" fill=\"rgba(6,182,212,0.18)\" data-v-e81027d4></circle><circle cx=\"780\" cy=\"180\" r=\"80\" fill=\"rgba(255,255,255,0.06)\" data-v-e81027d4></circle><path d=\"M 0 150 Q 200 100 400 130 T 800 110\" stroke=\"rgba(255,255,255,0.08)\" stroke-width=\"1\" fill=\"none\" data-v-e81027d4></path></svg></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)("UPGLV.pushRecordTitle")), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("UPGLV.pushRecordDesc")), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (lastRefreshTime.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
              _createElementVNode("span", {
                class: _normalizeClass(["live-dot", { active: autoRefresh.value }])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(_unref(t)("UPGLV.lastRefresh")) + ":" + _toDisplayString(lastRefreshTime.value), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_switch, {
          modelValue: autoRefresh.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((autoRefresh).value = $event)),
          "active-text": _unref(t)('UPGLV.autoRefreshOn'),
          "inactive-text": _unref(t)('UPGLV.autoRefreshOff'),
          class: "auto-refresh-switch"
        }, null, 8, ["modelValue", "active-text", "inactive-text"]),
        _createElementVNode("button", {
          class: _normalizeClass(["refresh-btn", { loading: loading.value }]),
          disabled: loading.value,
          onClick: handleRefresh
        }, [
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "ripple" }, null, -1)),
          _createVNode(_component_el_icon, { class: "refresh-icon" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Refresh))
            ]),
            _: 1
          }),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)("UPGLV.refresh")), 1)
        ], 10, _hoisted_8)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_icon, { class: "stat-icon" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Promotion))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)("UPGLV.statTotal")), 1),
          _createElementVNode("div", _hoisted_15, _toDisplayString(displayStats.value.total), 1),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", {
              class: "stat-progress-bar",
              style: _normalizeStyle({ width: displayStats.value.successRate + '%' })
            }, null, 4)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createTextVNode(_toDisplayString(_unref(t)("UPGLV.statSuccessRate")) + " ", 1),
            _createElementVNode("strong", _hoisted_18, _toDisplayString(displayStats.value.successRate) + "%", 1),
            _createTextVNode(" - " + _toDisplayString(_unref(t)("UPGLV.statUnitPage")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_el_icon, { class: "stat-icon" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CircleCheck))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)("UPGLV.statCompleted")), 1),
          _createElementVNode("div", _hoisted_23, _toDisplayString(displayStats.value.completed), 1),
          _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)("UPGLV.statSubCompleted", {
                0: displayStats.value.successCount,
                1: displayStats.value.partialCount,
              })), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createVNode(_component_el_icon, { class: "stat-icon is-loading" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Loading))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)("UPGLV.statProcessing")), 1),
          _createElementVNode("div", _hoisted_29, _toDisplayString(displayStats.value.processing), 1),
          _createElementVNode("div", _hoisted_30, _toDisplayString(_unref(t)("UPGLV.statSubProcessing", {
                0: displayStats.value.pending,
                1: displayStats.value.upgrading,
              })), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_component_el_icon, { class: "stat-icon" }, {
            default: _withCtx(() => [
              _createVNode(_unref(CircleClose))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, _toDisplayString(_unref(t)("UPGLV.statFailed")), 1),
          _createElementVNode("div", _hoisted_35, _toDisplayString(displayStats.value.failed), 1),
          _createElementVNode("div", _hoisted_36, _toDisplayString(_unref(t)("UPGLV.statSubFailed", {
                0: displayStats.value.rejected,
                1: displayStats.value.upgradeFailed,
              })), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createVNode(_component_el_icon, { class: "stat-icon" }, {
            default: _withCtx(() => [
              _createVNode(_unref(Clock))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(t)("UPGLV.statExpired")), 1),
          _createElementVNode("div", _hoisted_41, _toDisplayString(displayStats.value.expired), 1),
          _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(t)("UPGLV.statExpiredTip")), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_43, [
      _createVNode(_component_el_select, {
        modelValue: query.type,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((query.type) = $event)),
        placeholder: _unref(t)('UPGLV.filterTypeAll'),
        class: "filter-select filter-type",
        onChange: handleQuery
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOptions.value, (opt) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: opt.value ?? 'all',
              label: opt.label,
              value: opt.value ?? ''
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder"]),
      _createVNode(_component_el_select, {
        modelValue: query.resultStatus,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((query.resultStatus) = $event)),
        placeholder: _unref(t)('UPGLV.filterResultStatusAll'),
        clearable: "",
        class: "filter-select",
        onChange: handleQuery
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resultStatusOptions.value, (opt) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: opt.value,
              label: opt.label,
              value: opt.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder"]),
      _createVNode(_component_el_select, {
        modelValue: query.customerAttitude,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((query.customerAttitude) = $event)),
        placeholder: _unref(t)('UPGLV.filterAttitudeAll'),
        clearable: "",
        class: "filter-select",
        onChange: handleQuery
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attitudeOptions.value, (opt) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: opt.value,
              label: opt.label,
              value: opt.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "placeholder"]),
      _createVNode(_component_el_date_picker, {
        modelValue: query.timeRange,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((query.timeRange) = $event)),
        type: "datetimerange",
        "range-separator": "-",
        "start-placeholder": _unref(t)('UPGLV.timeRangePlaceholder'),
        "end-placeholder": _unref(t)('UPGLV.timeRangePlaceholder'),
        class: "filter-date",
        onChange: handleQuery
      }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"]),
      _createElementVNode("button", {
        class: "action-btn btn-primary",
        onClick: handleQuery
      }, [
        _createVNode(_component_el_icon, { class: "btn-icon" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Search))
          ]),
          _: 1
        }),
        _createElementVNode("span", null, _toDisplayString(_unref(t)("UPGLV.search")), 1)
      ]),
      _createElementVNode("button", {
        class: "action-btn btn-ghost",
        onClick: handleReset
      }, [
        _createVNode(_component_el_icon, { class: "btn-icon btn-icon-spin" }, {
          default: _withCtx(() => [
            _createVNode(_unref(RefreshLeft))
          ]),
          _: 1
        }),
        _createElementVNode("span", null, _toDisplayString(_unref(t)("UPGLV.reset")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_44, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: recordList.value,
        "row-key": "id",
        class: "record-table",
        "row-class-name": getRowClassName,
        onExpandChange: handleExpandChange
      }, {
        empty: _withCtx(() => [
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_el_icon, { class: "empty-icon" }, {
              default: _withCtx(() => [
                _createVNode(_unref(DocumentRemove))
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_46, _toDisplayString(_unref(t)("UPGLV.noData")), 1),
            _createElementVNode("div", _hoisted_47, _toDisplayString(_unref(t)("UPGLV.noDataHint")), 1)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "expand",
            width: "48"
          }, {
            default: _withCtx((scope) => [
              (scope.row.type === 2 || scope.row.type === 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                    (expandedItems.value[scope.row.id])
                      ? (_openBlock(), _createBlock(_component_el_table, {
                          key: 0,
                          data: expandedItems.value[scope.row.id],
                          size: "small",
                          border: "",
                          class: "item-table"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              label: _unref(t)('UPGLV.itemColSeq'),
                              prop: "sequence",
                              width: "60",
                              align: "center"
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: _unref(t)('UPGLV.itemColDevice'),
                              prop: "devName",
                              "min-width": "120"
                            }, {
                              default: _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(_unref(translateName)(row.devName)), 1)
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: _unref(t)('UPGLV.colType'),
                              width: "100"
                            }, {
                              default: _withCtx((s) => [
                                _createTextVNode(_toDisplayString(getSubTypeName(s.row.subType)), 1)
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: _unref(t)('UPGLV.itemColFile'),
                              prop: "fileName",
                              "min-width": "160",
                              "show-overflow-tooltip": ""
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: _unref(t)('UPGLV.itemColPush'),
                              width: "90",
                              align: "center"
                            }, {
                              default: _withCtx((s) => [
                                _createVNode(_component_el_tag, {
                                  type: tagOfPush(s.row.pushStatus),
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(nameOfPush(s.row.pushStatus)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: _unref(t)('UPGLV.itemColResponse'),
                              width: "90",
                              align: "center"
                            }, {
                              default: _withCtx((s) => [
                                _createVNode(_component_el_tag, {
                                  type: tagOfResp(s.row.responseStatus),
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(nameOfResp(s.row.responseStatus)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: _unref(t)('UPGLV.itemColResult'),
                              width: "90",
                              align: "center"
                            }, {
                              default: _withCtx((s) => [
                                _createVNode(_component_el_tag, {
                                  type: tagOfItemResult(s.row.resultStatus),
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(nameOfItemResult(s.row.resultStatus)), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["type"])
                              ]),
                              _: 1
                            }, 8, ["label"]),
                            _createVNode(_component_el_table_column, {
                              label: _unref(t)('UPGLV.itemColError'),
                              prop: "errorCode",
                              width: "80",
                              align: "center"
                            }, {
                              default: _withCtx((s) => [
                                _createTextVNode(_toDisplayString(s.row.errorCode || "-"), 1)
                              ]),
                              _: 1
                            }, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["data"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_49, [
                          _createVNode(_component_el_icon, { class: "is-loading" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Loading))
                            ]),
                            _: 1
                          })
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('UPGLV.colType'),
            width: "110"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_component_el_icon, {
                  class: "type-icon",
                  style: _normalizeStyle({ color: typeMeta(scope.row.type).color })
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(typeMeta(scope.row.type).icon)))
                  ]),
                  _: 2
                }, 1032, ["style"]),
                _createVNode(_component_el_tag, {
                  type: typeMeta(scope.row.type).tag,
                  size: "small",
                  effect: "light"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(typeMeta(scope.row.type).label), 1)
                  ]),
                  _: 2
                }, 1032, ["type"])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('UPGLV.colPlan'),
            width: "200",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_51, [
                _createElementVNode("span", _hoisted_52, _toDisplayString(scope.row.planName || "-"), 1),
                _createElementVNode("span", _hoisted_53, _toDisplayString(shortId(scope.row.refId || scope.row.id, 12)), 1)
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('UPGLV.colShip'),
            width: "150",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("span", _hoisted_55, _toDisplayString(scope.row.shipName || "-"), 1),
                _createElementVNode("span", _hoisted_56, _toDisplayString(shortId(scope.row.shipId, 8)), 1)
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('UPGLV.colAttitude'),
            width: "80",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              (scope.row.needConsent === 1)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: tagOfAttitude(scope.row.customerAttitude),
                    size: "small",
                    effect: "plain"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(nameOfAttitude(scope.row.customerAttitude)), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"]))
                : (_openBlock(), _createElementBlock("span", _hoisted_57, "-"))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('UPGLV.colResult'),
            width: "100",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_tag, {
                type: tagOfResult(scope.row.resultStatus),
                size: "small",
                effect: "dark"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(nameOfResultByType(scope.row.resultStatus, scope.row.type)), 1)
                ]),
                _: 2
              }, 1032, ["type"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('UPGLV.colProgress'),
            width: "150",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              (scope.row.totalItems > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createVNode(_component_el_progress, {
                      percentage: progressPct(scope.row),
                      status: progressStatus(scope.row.resultStatus),
                      "stroke-width": 8
                    }, null, 8, ["percentage", "status"]),
                    _createElementVNode("span", _hoisted_59, _toDisplayString(scope.row.successItems) + "/" + _toDisplayString(scope.row.totalItems), 1)
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_60, "-"))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('UPGLV.colTime'),
            width: "200"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("span", _hoisted_63, _toDisplayString(_unref(t)("UPGLV.timelinePush")), 1),
                  _createElementVNode("span", null, _toDisplayString(formatTime(scope.row.pushTime)), 1)
                ]),
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("span", _hoisted_65, _toDisplayString(_unref(t)("UPGLV.timelineResult")), 1),
                  _createElementVNode("span", null, _toDisplayString(formatTime(scope.row.resultTime)), 1)
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _unref(t)('UPGLV.colActions'),
            width: "130",
            align: "center",
            fixed: "right"
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_66, [
                _createVNode(_component_el_tooltip, {
                  content: _unref(t)('UPGLV.actionDetail'),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      class: "row-action-btn btn-view",
                      onClick: _withModifiers(($event: any) => (openDetail(scope.row)), ["stop"])
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(View))
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_67)
                  ]),
                  _: 2
                }, 1032, ["content"]),
                (canRetry(scope.row))
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      content: _unref(t)('UPGLV.actionRetry'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "row-action-btn btn-retry",
                          disabled: loadingMap.value.get('retry-' + scope.row.id),
                          onClick: _withModifiers(($event: any) => (handleRetry(scope.row)), ["stop"])
                        }, [
                          (!loadingMap.value.get('retry-' + scope.row.id))
                            ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(RefreshRight))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_icon, {
                                key: 1,
                                class: "is-loading"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Loading))
                                ]),
                                _: 1
                              }))
                        ], 8, _hoisted_68)
                      ]),
                      _: 2
                    }, 1032, ["content"]))
                  : _createCommentVNode("", true),
                (canCancel(scope.row))
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 1,
                      content: _unref(t)('UPGLV.actionCancel'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "row-action-btn btn-danger",
                          disabled: loadingMap.value.get('cancel-' + scope.row.id),
                          onClick: _withModifiers(($event: any) => (handleCancel(scope.row)), ["stop"])
                        }, [
                          (!loadingMap.value.get('cancel-' + scope.row.id))
                            ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(CircleClose))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_icon, {
                                key: 1,
                                class: "is-loading"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Loading))
                                ]),
                                _: 1
                              }))
                        ], 8, _hoisted_69)
                      ]),
                      _: 2
                    }, 1032, ["content"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, loading.value]
      ]),
      _createElementVNode("div", _hoisted_70, [
        _createVNode(_component_el_pagination, {
          "current-page": currentPage.value,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((currentPage).value = $event)),
          "page-size": pageSize,
          total: total.value,
          layout: "total, prev, pager, next, jumper",
          background: "",
          onCurrentChange: handlePageChange
        }, null, 8, ["current-page", "total"])
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: detailVisible.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((detailVisible).value = $event)),
      direction: "rtl",
      size: "560px",
      "destroy-on-close": "",
      onOpen: onDrawerOpen
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_71, [
          _createElementVNode("span", _hoisted_72, _toDisplayString(_unref(t)("UPGLV.detailTitle")), 1),
          (currentDetail.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                (canRetry(currentDetail.value))
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      content: _unref(t)('UPGLV.actionRetry'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "drawer-action-btn btn-retry",
                          disabled: loadingMap.value.get('retry-' + currentDetail.value.id),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (handleRetry(currentDetail.value)))
                        }, [
                          (!loadingMap.value.get('retry-' + currentDetail.value.id))
                            ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(RefreshRight))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_icon, {
                                key: 1,
                                class: "is-loading"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Loading))
                                ]),
                                _: 1
                              })),
                          _createElementVNode("span", null, _toDisplayString(_unref(t)("UPGLV.actionRetry")), 1)
                        ], 8, _hoisted_74)
                      ]),
                      _: 1
                    }, 8, ["content"]))
                  : _createCommentVNode("", true),
                (canCancel(currentDetail.value))
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 1,
                      content: _unref(t)('UPGLV.actionCancel'),
                      placement: "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("button", {
                          class: "drawer-action-btn btn-danger",
                          disabled: loadingMap.value.get('cancel-' + currentDetail.value.id),
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (handleCancel(currentDetail.value)))
                        }, [
                          (!loadingMap.value.get('cancel-' + currentDetail.value.id))
                            ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(CircleClose))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_el_icon, {
                                key: 1,
                                class: "is-loading"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(Loading))
                                ]),
                                _: 1
                              })),
                          _createElementVNode("span", null, _toDisplayString(_unref(t)("UPGLV.actionCancel")), 1)
                        ], 8, _hoisted_75)
                      ]),
                      _: 1
                    }, 8, ["content"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        (currentDetail.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createVNode(_component_el_tag, {
                  type: typeMeta(currentDetail.value.type).tag,
                  effect: "dark",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(typeMeta(currentDetail.value.type).label), 1)
                  ]),
                  _: 1
                }, 8, ["type"]),
                _createVNode(_component_el_tag, {
                  type: tagOfResult(currentDetail.value.resultStatus),
                  effect: "dark",
                  size: "large"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(nameOfResult(currentDetail.value.resultStatus)), 1)
                  ]),
                  _: 1
                }, 8, ["type"]),
                _createElementVNode("div", _hoisted_78, _toDisplayString(currentDetail.value.planName || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, _toDisplayString(_unref(t)("UPGLV.detailBasic")), 1),
                _createVNode(_component_el_descriptions, {
                  column: 2,
                  border: "",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_descriptions_item, {
                      label: _unref(t)('UPGLV.labelShip')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(currentDetail.value.shipName || "-"), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_descriptions_item, {
                      label: _unref(t)('UPGLV.colEndpoint')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_81, _toDisplayString(currentDetail.value.endpointId || "-"), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_descriptions_item, {
                      label: _unref(t)('UPGLV.labelPlan')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_82, _toDisplayString(currentDetail.value.refId || currentDetail.value.id), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_descriptions_item, {
                      label: _unref(t)('UPGLV.labelNeedConsent')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(currentDetail.value.needConsent === 1
                  ? _unref(t)("UPGLV.labelYes")
                  : _unref(t)("UPGLV.labelNo")), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    (currentDetail.value.needConsent === 1)
                      ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                          key: 0,
                          label: _unref(t)('UPGLV.colAttitude')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_tag, {
                              type: tagOfAttitude(currentDetail.value.customerAttitude),
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(nameOfAttitude(currentDetail.value.customerAttitude)), 1)
                              ]),
                              _: 1
                            }, 8, ["type"])
                          ]),
                          _: 1
                        }, 8, ["label"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_descriptions_item, {
                      label: _unref(t)('UPGLV.labelOperator')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(currentDetail.value.managerId || "-"), 1)
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_descriptions_item, {
                      label: _unref(t)('UPGLV.labelDetail'),
                      span: 2
                    }, {
                      default: _withCtx(() => [
                        (isUrlLike(currentDetail.value.detail))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(_unref(t)("UPGLV.labelDetailNone")), 1))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(_toDisplayString(currentDetail.value.detail || "-"), 1)
                            ], 64))
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              (fileInfo.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, _toDisplayString(_unref(t)("UPGLV.detailFile")), 1),
                    _createElementVNode("div", _hoisted_86, [
                      _createVNode(_component_el_icon, { class: "file-icon" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Document))
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("div", _hoisted_88, _toDisplayString(fileInfo.value.fileName), 1),
                        (fileInfo.value.fileMd5)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
                              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "meta-label" }, "MD5", -1)),
                              _createElementVNode("span", _hoisted_90, _toDisplayString(fileInfo.value.fileMd5), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (fileInfo.value.md5FileName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "meta-label" }, "MD5文件", -1)),
                              _createElementVNode("span", _hoisted_92, _toDisplayString(fileInfo.value.md5FileName), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (fileInfo.value.signFileName)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_93, [
                              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "meta-label" }, "签名文件", -1)),
                              _createElementVNode("span", _hoisted_94, _toDisplayString(fileInfo.value.signFileName), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_95, [
                _createElementVNode("div", _hoisted_96, _toDisplayString(_unref(t)("UPGLV.detailTimeline")), 1),
                _createVNode(_component_el_timeline, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_timeline_item, {
                      timestamp: formatTime(currentDetail.value.createtime),
                      placement: "top",
                      color: "#909399"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_97, _toDisplayString(_unref(t)("UPGLV.timelineCreate")), 1)
                      ]),
                      _: 1
                    }, 8, ["timestamp"]),
                    _createVNode(_component_el_timeline_item, {
                      timestamp: formatTime(currentDetail.value.pushTime),
                      placement: "top",
                      color: currentDetail.value.pushTime ? '#409eff' : '#909399'
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_98, _toDisplayString(_unref(t)("UPGLV.timelinePush")), 1),
                        (currentDetail.value.pushTime)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: tagOfPush(currentDetail.value.pushStatus),
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(nameOfPush(currentDetail.value.pushStatus)), 1)
                              ]),
                              _: 1
                            }, 8, ["type"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(_unref(t)("UPGLV.timelinePending")), 1))
                      ]),
                      _: 1
                    }, 8, ["timestamp", "color"]),
                    _createVNode(_component_el_timeline_item, {
                      timestamp: formatTime(currentDetail.value.responseTime),
                      placement: "top",
                      color: timelineColorOfResp(currentDetail.value.responseStatus)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_100, _toDisplayString(_unref(t)("UPGLV.timelineResponse")), 1),
                        (currentDetail.value.responseTime)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: tagOfResp(currentDetail.value.responseStatus),
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(nameOfResp(currentDetail.value.responseStatus)), 1)
                              ]),
                              _: 1
                            }, 8, ["type"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_101, _toDisplayString(_unref(t)("UPGLV.timelinePending")), 1))
                      ]),
                      _: 1
                    }, 8, ["timestamp", "color"]),
                    _createVNode(_component_el_timeline_item, {
                      timestamp: formatTime(currentDetail.value.resultTime),
                      placement: "top",
                      color: timelineColorOfResult(currentDetail.value.resultStatus)
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_102, _toDisplayString(_unref(t)("UPGLV.timelineResult")), 1),
                        (currentDetail.value.resultTime)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 0,
                              type: tagOfResult(currentDetail.value.resultStatus),
                              size: "small",
                              effect: "dark"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(nameOfResult(currentDetail.value.resultStatus)), 1)
                              ]),
                              _: 1
                            }, 8, ["type"]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_103, _toDisplayString(_unref(t)("UPGLV.timelinePending")), 1))
                      ]),
                      _: 1
                    }, 8, ["timestamp", "color"])
                  ]),
                  _: 1
                })
              ]),
              (currentDetail.value.type === 2 || currentDetail.value.type === 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                    _createElementVNode("div", _hoisted_105, [
                      _createTextVNode(_toDisplayString(currentDetail.value.type === 4
                ? _unref(t)("UPGLV.detailProtocolItems")
                : _unref(t)("UPGLV.detailItems")) + " ", 1),
                      (detailItems.value.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_106, "(" + _toDisplayString(detailItems.value.length) + ")", 1))
                        : _createCommentVNode("", true)
                    ]),
                    (detailItemsLoading.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_107, [
                          _createVNode(_component_el_icon, { class: "is-loading" }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Loading))
                            ]),
                            _: 1
                          })
                        ]))
                      : (detailItems.value.length)
                        ? (_openBlock(), _createBlock(_component_el_table, {
                            key: 1,
                            data: detailItems.value,
                            size: "small",
                            border: ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table_column, {
                                label: _unref(t)('UPGLV.itemColSeq'),
                                prop: "sequence",
                                width: "60",
                                align: "center"
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _unref(t)('UPGLV.itemColDevice'),
                                prop: "devName",
                                "min-width": "120",
                                "show-overflow-tooltip": ""
                              }, {
                                default: _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(_unref(translateName)(row.devName)), 1)
                                ]),
                                _: 1
                              }, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _unref(t)('UPGLV.itemColFile'),
                                prop: "fileName",
                                "min-width": "140",
                                "show-overflow-tooltip": ""
                              }, null, 8, ["label"]),
                              _createVNode(_component_el_table_column, {
                                label: _unref(t)('UPGLV.itemColResult'),
                                width: "100",
                                align: "center"
                              }, {
                                default: _withCtx((s) => [
                                  _createVNode(_component_el_tag, {
                                    type: tagOfItemResult(s.row.resultStatus),
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(nameOfItemResult(s.row.resultStatus)), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["type"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          }, 8, ["data"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_108, _toDisplayString(_unref(t)("UPGLV.detailItemsEmpty")), 1))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})